// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.package-plan-creation-modal .ant-modal {
  max-width: calc(100vw - 32px);
}
.package-plan-creation-modal .ant-modal-content {
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 18px 48px rgba(15, 35, 62, 0.18);
}
.package-plan-creation-modal .ant-modal-header {
  min-height: 64px;
  margin: 0;
  padding: 21px 26px;
  border-bottom: 1px solid #e5edf5;
  background: #f6f9fd;
}
.package-plan-creation-modal .ant-modal-title {
  color: #064fa9;
  font-size: 18px;
  font-weight: 700;
}
.package-plan-creation-modal .ant-modal-close {
  top: 7px;
  right: 7px;
  color: #51677f;
}
.package-plan-creation-modal .ant-modal-close:hover {
  color: #075dc5;
}
.package-plan-creation-modal .ant-modal-body {
  padding: 30px 34px 32px;
}

.package-plan-creation-form .ant-form-item {
  margin-bottom: 24px !important;
}
.package-plan-creation-form .ant-form-item:not(.package-plan-creation-actions) .ant-form-item-row {
  display: grid;
  grid-template-columns: 180px minmax(0, 1fr);
  column-gap: 24px;
  align-items: center;
}
.package-plan-creation-form .ant-form-item:not(.package-plan-creation-actions) .ant-form-item-label {
  width: 180px;
  max-width: 180px;
  padding: 0;
  text-align: left;
}
.package-plan-creation-form .ant-form-item:not(.package-plan-creation-actions) .ant-form-item-label > label {
  display: flex;
  align-items: flex-start;
  height: auto;
  color: #172033;
  font-size: 14px;
  font-weight: 600;
}
.package-plan-creation-form .ant-form-item:not(.package-plan-creation-actions) .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
  margin-top: 2px;
}
.package-plan-creation-form .ant-form-item:not(.package-plan-creation-actions) .ant-form-item-control {
  min-width: 0;
  max-width: none;
}
.package-plan-creation-form .package-plan-creation-actions .ant-form-item-row {
  display: block;
}
.package-plan-creation-form .package-plan-field-label {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}
.package-plan-creation-form .package-plan-field-link {
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 10px;
  border: 1px solid #b9c9da;
  border-radius: 5px;
  color: #075dc5;
  font-size: 12px;
  font-weight: 600;
  line-height: 26px;
  text-decoration: none;
}
.package-plan-creation-form .package-plan-field-link:hover, .package-plan-creation-form .package-plan-field-link:focus {
  border-color: #075dc5;
  background: #f3f8ff;
  color: #064fa9;
}
.package-plan-creation-form .ant-input,
.package-plan-creation-form .ant-input-number,
.package-plan-creation-form .ant-select-selector {
  width: 100% !important;
  min-height: 42px !important;
  border: 1px solid #ccd8e5 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
}
.package-plan-creation-form .ant-input,
.package-plan-creation-form .ant-input-number-input {
  padding: 9px 12px;
  color: #172033;
}
.package-plan-creation-form .ant-input[disabled] {
  color: #60758d;
  background: #f7f9fc;
}
.package-plan-creation-form .ant-select-single .ant-select-selector {
  display: flex;
  align-items: center;
}
.package-plan-creation-form .ant-select-multiple {
  height: auto !important;
  max-height: none !important;
  overflow: visible !important;
}
.package-plan-creation-form .ant-select-multiple .ant-select-selector {
  height: auto !important;
  min-height: 42px !important;
  padding: 4px 10px !important;
  overflow: visible !important;
}
.package-plan-creation-form .ant-select-multiple .ant-select-selection-overflow {
  flex-wrap: wrap !important;
  row-gap: 4px;
}
.package-plan-creation-form .ant-select-multiple .ant-select-clear {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  top: 13px;
  right: 6px;
  color: #60758d;
  opacity: 1;
}
.package-plan-creation-form .ant-input:hover,
.package-plan-creation-form .ant-input:focus,
.package-plan-creation-form .ant-input-number:hover,
.package-plan-creation-form .ant-input-number-focused,
.package-plan-creation-form .ant-select-focused .ant-select-selector,
.package-plan-creation-form .ant-select-selector:hover {
  border-color: #075dc5 !important;
  box-shadow: 0 0 0 2px rgba(7, 93, 197, 0.08) !important;
}
.package-plan-creation-form .package-plan-creation-actions {
  margin: 30px 0 0 !important;
  padding-top: 24px;
  border-top: 1px solid #e5edf5;
}
.package-plan-creation-form .package-plan-creation-actions .ant-btn {
  min-width: 108px;
  height: 42px;
  border-radius: 6px;
  border-color: #b9c9da;
  color: #172033;
  font-size: 14px;
  font-weight: 600;
  box-shadow: none;
}
.package-plan-creation-form .package-plan-creation-actions .ant-btn-primary {
  border-color: #075dc5 !important;
  background: #075dc5 !important;
  color: #fff !important;
}`, "",{"version":3,"sources":["webpack://./src/components/PackagePlanSelection/PlanCreationModal.scss"],"names":[],"mappings":"AACE;EACE,6BAAA;AAAJ;AAGE;EACE,gBAAA;EACA,mBAAA;EACA,8CAAA;AADJ;AAIE;EACE,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;AAFJ;AAKE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAHJ;AAME;EACE,QAAA;EACA,UAAA;EACA,cAAA;AAJJ;AAMI;EACE,cAAA;AAJN;AAQE;EACE,uBAAA;AANJ;;AAWE;EACE,8BAAA;AARJ;AAcI;EACE,aAAA;EACA,2CAAA;EACA,gBAAA;EACA,mBAAA;AAZN;AAeI;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;AAbN;AAeM;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAbR;AAeQ;EACE,eAAA;AAbV;AAkBI;EACE,YAAA;EACA,eAAA;AAhBN;AAqBI;EACE,cAAA;AAnBN;AAuBE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AArBJ;AAyBE;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AAvBJ;AAyBI;EAEE,qBAAA;EACA,mBAAA;EACA,cAAA;AAxBN;AA4BE;;;EAGE,sBAAA;EACA,2BAAA;EACA,oCAAA;EACA,6BAAA;EACA,2BAAA;AA1BJ;AA6BE;;EAEE,iBAAA;EACA,cAAA;AA3BJ;AA8BE;EACE,cAAA;EACA,mBAAA;AA5BJ;AA+BE;EACE,aAAA;EACA,mBAAA;AA7BJ;AAgCE;EACE,uBAAA;EACA,2BAAA;EACA,4BAAA;AA9BJ;AAgCI;EACE,uBAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;AA9BN;AAiCI;EACE,0BAAA;EACA,YAAA;AA/BN;AAkCI;EACE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,UAAA;AAhCN;AAoCE;;;;;;EAME,gCAAA;EACA,uDAAA;AAlCJ;AAqCE;EACE,2BAAA;EACA,iBAAA;EACA,6BAAA;AAnCJ;AAqCI;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAnCN;AAsCI;EACE,gCAAA;EACA,8BAAA;EACA,sBAAA;AApCN","sourcesContent":[".package-plan-creation-modal {\n  .ant-modal {\n    max-width: calc(100vw - 32px);\n  }\n\n  .ant-modal-content {\n    overflow: hidden;\n    border-radius: 10px;\n    box-shadow: 0 18px 48px rgba(15, 35, 62, 0.18);\n  }\n\n  .ant-modal-header {\n    min-height: 64px;\n    margin: 0;\n    padding: 21px 26px;\n    border-bottom: 1px solid #e5edf5;\n    background: #f6f9fd;\n  }\n\n  .ant-modal-title {\n    color: #064fa9;\n    font-size: 18px;\n    font-weight: 700;\n  }\n\n  .ant-modal-close {\n    top: 7px;\n    right: 7px;\n    color: #51677f;\n\n    &:hover {\n      color: #075dc5;\n    }\n  }\n\n  .ant-modal-body {\n    padding: 30px 34px 32px;\n  }\n}\n\n.package-plan-creation-form {\n  .ant-form-item {\n    margin-bottom: 24px !important;\n  }\n\n  // Every field uses one stable label/control grid. The action row is kept\n  // separate so its existing buttons retain their natural right alignment.\n  .ant-form-item:not(.package-plan-creation-actions) {\n    .ant-form-item-row {\n      display: grid;\n      grid-template-columns: 180px minmax(0, 1fr);\n      column-gap: 24px;\n      align-items: center;\n    }\n\n    .ant-form-item-label {\n      width: 180px;\n      max-width: 180px;\n      padding: 0;\n      text-align: left;\n\n      > label {\n        display: flex;\n        align-items: flex-start;\n        height: auto;\n        color: #172033;\n        font-size: 14px;\n        font-weight: 600;\n\n        &.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {\n          margin-top: 2px;\n        }\n      }\n    }\n\n    .ant-form-item-control {\n      min-width: 0;\n      max-width: none;\n    }\n  }\n\n  .package-plan-creation-actions {\n    .ant-form-item-row {\n      display: block;\n    }\n  }\n\n  .package-plan-field-label {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n  }\n  \n\n  .package-plan-field-link {\n    display: inline-flex;\n    align-items: center;\n    height: 28px;\n    padding: 0 10px;\n    border: 1px solid #b9c9da;\n    border-radius: 5px;\n    color: #075dc5;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 26px;\n    text-decoration: none;\n\n    &:hover,\n    &:focus {\n      border-color: #075dc5;\n      background: #f3f8ff;\n      color: #064fa9;\n    }\n  }\n\n  .ant-input,\n  .ant-input-number,\n  .ant-select-selector {\n    width: 100% !important;\n    min-height: 42px !important;\n    border: 1px solid #ccd8e5 !important;\n    border-radius: 6px !important;\n    box-shadow: none !important;\n  }\n\n  .ant-input,\n  .ant-input-number-input {\n    padding: 9px 12px;\n    color: #172033;\n  }\n\n  .ant-input[disabled] {\n    color: #60758d;\n    background: #f7f9fc;\n  }\n\n  .ant-select-single .ant-select-selector {\n    display: flex;\n    align-items: center;\n  }\n\n  .ant-select-multiple {\n    height: auto !important;\n    max-height: none !important;\n    overflow: visible !important;\n\n    .ant-select-selector {\n      height: auto !important;\n      min-height: 42px !important;\n      padding: 4px 10px !important;\n      overflow: visible !important;\n    }\n\n    .ant-select-selection-overflow {\n      flex-wrap: wrap !important;\n      row-gap: 4px;\n    }\n\n    .ant-select-clear {\n      display: inline-flex !important;\n      align-items: center;\n      justify-content: center;\n      top: 13px;\n      right: 6px;\n      color: #60758d;\n      opacity: 1;\n    }\n  }\n\n  .ant-input:hover,\n  .ant-input:focus,\n  .ant-input-number:hover,\n  .ant-input-number-focused,\n  .ant-select-focused .ant-select-selector,\n  .ant-select-selector:hover {\n    border-color: #075dc5 !important;\n    box-shadow: 0 0 0 2px rgba(7, 93, 197, 0.08) !important;\n  }\n\n  .package-plan-creation-actions {\n    margin: 30px 0 0 !important;\n    padding-top: 24px;\n    border-top: 1px solid #e5edf5;\n\n    .ant-btn {\n      min-width: 108px;\n      height: 42px;\n      border-radius: 6px;\n      border-color: #b9c9da;\n      color: #172033;\n      font-size: 14px;\n      font-weight: 600;\n      box-shadow: none;\n    }\n\n    .ant-btn-primary {\n      border-color: #075dc5 !important;\n      background: #075dc5 !important;\n      color: #fff !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
